import React from 'react';
import './Hero.css';

const Hero = () => (
  <section className="homev2-hero">
    <div className="homev2-hero__content">
      <div className="homev2-hero__info-container">
        <h1 className="homev2-hero__headline">Welcome to One-Time Fantasy!</h1>
        <p className="homev2-hero__subheadline">
          Are you ready to draft real-life competitors from live poker events? Create your team, watch live events unfold, and compete to win huge prizes!
        </p>
      </div>
      <a href="/signup" className="homev2-hero__cta">Sign Up Now!</a>
    </div>
  </section>
);

export default Hero; 